export const IDENTITY_MIGRATION_SQL = `
CREATE TABLE device_identity_metadata (
  id INTEGER PRIMARY KEY NOT NULL CHECK (id = 1),
  custody_mode TEXT NOT NULL CHECK (custody_mode IN ('non-extractable', 'wrapped')),
  did TEXT NOT NULL,
  node_id TEXT NOT NULL,
  public_key_multibase TEXT NOT NULL,
  imported_at TEXT NOT NULL
) STRICT;

CREATE TABLE delegation_metadata (
  id INTEGER PRIMARY KEY NOT NULL CHECK (id = 1),
  revocation_id TEXT NOT NULL,
  scopes_json TEXT NOT NULL,
  issued_at TEXT NOT NULL,
  expires_at TEXT NOT NULL,
  imported_at TEXT NOT NULL
) STRICT;

CREATE INDEX idx_delegation_expiry ON delegation_metadata(expires_at);

CREATE TABLE home_node_candidates (
  address TEXT PRIMARY KEY NOT NULL,
  kind TEXT NOT NULL CHECK (kind IN ('direct', 'relay')),
  state TEXT NOT NULL CHECK (state IN ('active', 'unavailable')) DEFAULT 'active',
  last_connected_at TEXT,
  lease_expires_at TEXT,
  imported_at TEXT NOT NULL
) STRICT;

CREATE INDEX idx_home_node_candidates_state
  ON home_node_candidates(state, last_connected_at);
CREATE INDEX idx_home_node_candidates_lease_expiry
  ON home_node_candidates(lease_expires_at) WHERE lease_expires_at IS NOT NULL;

CREATE TABLE identity_import_state (
  source TEXT PRIMARY KEY NOT NULL,
  imported_at TEXT NOT NULL
) STRICT;
`;
//# sourceMappingURL=003_identity.sql.js.map